import React from "react";
import { Provider } from "react-redux";
import { Route } from "react-router";
import { ConnectedRouter } from "connected-react-router";

import { store, history } from "../containers/duck";
import FilterContainer from "../containers/FilterContainer";

const FilterApp = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route
        path={`/${window.location.pathname.split("/")[1]}`}
        component={FilterContainer}
      />
    </ConnectedRouter>
  </Provider>
);

export default FilterApp;
